import { createGlobalStyle } from 'styled-components'

export const EstiloGlobal = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Roboto', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    color: #42526E;
  }
`;